/**
 * This file is the global include file. It is included on every page
 * in the front end.
 *
 * Include other files via `import` below.
 */

// Deps
import $ from 'jquery';
import videoPlayerResponsive from './src/_video-player';
import skipLinkFocus from './src/_skip-link-focus-fix';
import navigation from './src/_navigation';
import advertisement from './src/_ads';
import { initHeaderSlider, initModuleSlickSlider, initSliders } from './src/_slider';
import initShowMorePosts from './src/_show-more-posts';
import initSearch from './src/_search';
import initHeaderHamburger from './src/_header';
import initCharacterTabs from './src/_character';
import initBlogContent from './src/ajax/_blog-content';
import initSeriesContent from './src/ajax/_series-content';
import initSelect from './src/_select';
import initLanguageMenu from './src/_language';

//Pass jquery to global scope
window.jQuery = $;
window.$ = $;


// Site / Global
skipLinkFocus();

// Components
advertisement();
videoPlayerResponsive();
navigation();


// Window load
$(window).on('load', function () {
    initLanguageMenu();
    initSliders();
    initHeaderHamburger();
    initHeaderSlider();
    initSelect();
    initShowMorePosts();
    initModuleSlickSlider();
    initSearch();
    initBlogContent();
    initSeriesContent();
    initCharacterTabs();
});